<template>
    <div class="wrapper">
        <el-input v-model="form.keywords" class="keywords"
            placeholder="Search keyword"
            v-on:change="handleInputChange"
        >
            <img slot="prefix" :src="icons[0].src" :alt="icons[0].alt"/>
        </el-input>
    </div>
</template>

<script>
  //import mixpanel from '@/utils/mixpanel.js'
  import {getCookie} from '@/tools/cookie'
  export default {
    props: {
      form: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        icons: [
          {
            src: require('@/assets/common/ic-search-gray.svg'),
            alt: "ic-search",
            width: "",
          }
        ]
      }
    },
    methods: {
      handleInputChange() {
        const form = this.form;
        this.$emit('search', form.keywords);
        // const params = this.cookieParams();
        // mixpanel.track('Job Board Page', {
        //   'Keyword Searched': 'Keyword Searched',
        // });
      },
      cookieParams() {
        const userId = getCookie('userId') || '';
        const distinct = getCookie('distinct-id') || '';
        const deviceId = getCookie('device-id') || '';
        const version = getCookie('tp-version-code') || '';
        return {
          userId,
          distinct,
          deviceId,
          version
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.wrapper {
	background-color: #fff;
	padding: 0 15px;
	margin-bottom: 15px;
	display: flex;
	.filter-button {
		text-align: right;
		margin: 24px 0;
		span {
			cursor: pointer;
			font-size: 32px;
			font-weight: 500;
			line-height: 40px;
			color: #5a6272;
			.icon {
				font-size: 40px;
			}
			&.is-active {
				color: #4285f4;
			}
		}
	}
	.button {
		width: 100%;
		height: 80px;
		font-size: 32px;
		font-weight: bold;
		img {
			width: 44px;
			height: 44px;
		}
		img,
		span {
			vertical-align: middle;
		}
	}
	.keywords {
		.el-input__suffix {
			img {
				margin-top: 7px;
			}
		}
	}
}
</style>

<style lang="scss">
.keywords {

    .el-input__prefix {
        top: 8px !important;
        left: 10px !important;
    }
    .el-input__inner {
        background-color: rgb(236, 239, 245)!important;
        font-family: SFProText-Regular;
        font-size: 15pt;
        padding-left: 40px;
    }
}
</style>
